import { AxiosResponse } from "axios"
import { apiUrl } from "../helpers/constants/config.constants"
import { httpDelete, httpGet, httpPatch, httpPost, httpPut } from "./http.service"
import { User } from "./user.service"
import { CustomerModel } from "./customer.service"

export type Service = {
  serviceId: string
  projectId: string
  ownerId: string
  serviceType: string
  price: number
  currency: string
  discount?: number
  unitType?: string
  unitValue?: string
  code: string
  title: string
  description?: string
  remark?: string
  status: string
  metadata?: string
  createdBy: string
  createdAt: Date
  updatedBy: string
  updatedAt: Date
  deletedAt?: Date
  isSubscription?: boolean
  subscriptionLimit?: number
  subscriptionDuration?: number
  validFrom?: Date
  validTo?: Date
}

export type Booking = {
  serviceBookingId: string
  projectId: string
  serviceId: string
  service: Service
  customerId: string
  customer: CustomerModel
  attendedBy: string
  attendedByUser: User
  attendedAddress: string
  isExternal: boolean
  reservationDuration: number
  reservationDateTime: Date
  reservationEndDateTime: Date
  totalPrice: number
  paymentStatus: string
  paymentMethod: string
  status: string
  remark?: string
  createdBy: string
  createdAt: Date
  updatedBy: string
  updatedAt: Date
  deletedAt?: Date
  serviceJson: Service[]
}

export type BookingItem = {
  serviceBookingItemId: string
  serviceBookingId: string
  serviceId: string
  serviceObject: Service
  attendedBy: string[]
  price: number
  quantity: number
  subTotal: number
  subscriptionId?: string
  subscriptionExpiredAt?: Date
  subscriptionCount?: number
  createdBy: string
  createdAt: Date
  updatedBy: string
  updatedAt: Date
  deletedAt?: Date
}

export const serviceBookingStatus = {
  pending: 'pending',
  confirmed: 'confirmed',
  cancelled: 'cancelled',
  completed: 'completed',
  noShow: 'no_show',
}

export const doListServices = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.service.list, { skip }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doGetService = (serviceId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.service.get(serviceId)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doCreateService = (params: any) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.service.create, params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doUpdateService = (params: any) => {
  return new Promise((resolve, reject) => {
    httpPut(apiUrl.service.update(params.serviceId), params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doDeleteService = (serviceId: string) => {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.service.delete(serviceId)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doListBookings = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.booking.list, { skip }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doGetBooking = (bookingId: string) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.booking.get(bookingId)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doCreateBooking = (params: any) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.booking.create, params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doUpdateBooking = (params: any) => {
  return new Promise((resolve, reject) => {
    httpPatch(apiUrl.booking.update(params.serviceBookingId), params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doGetAttendedBy = () => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.booking.attendedBy).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doGetServiceTypes = () => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.service.types).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doListServiceCustomForms = (skip: number) => {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.service.customForm.list, { skip }).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doCreateServiceCustomForm = (params: any) => {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.service.customForm.create, params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doUpdateServiceCustomForm = (params: any) => {
  return new Promise((resolve, reject) => {
    httpPut(apiUrl.service.customForm.update(params.serviceCustomFormId), params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  });
}

export const doDeleteServiceCustomForm = (serviceCustomFormId: string) => {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.service.customForm.delete(serviceCustomFormId)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export function doListServiceType() {
  return new Promise((resolve, reject) => {
    httpGet(apiUrl.service.type.list).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

export function doCreateServiceType(params: any) {
  return new Promise((resolve, reject) => {
    httpPost(apiUrl.service.type.create, params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    })
  })
}

export function doUpdateServiceType(params: any) {
  return new Promise((resolve, reject) => {
    httpPut(apiUrl.service.type.update(params.serviceTypeId), params).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    })
  })
}

export function doDeleteServiceType(serviceTypeId: string) {
  return new Promise((resolve, reject) => {
    httpDelete(apiUrl.service.type.delete(serviceTypeId)).then((res) => {
      const response = res as AxiosResponse
      resolve(response)
    }).catch((error: Error) => {
      reject(error)
    })
  })
}
